module.exports = __webpack_public_path__ + "static/media/ico_simulation_category_noses.f35e0c90.png";